import { generateMutations } from '../builder'

export default {
  ...generateMutations('getGenres', 'genres'),
  ...generateMutations('saveGenre', 'genre'),
  ...generateMutations('getGenre', 'genre'),
  ...generateMutations('deleteGenre'),
}
